module.exports = __webpack_public_path__ + "136d3798f43761a4d7c2ada52543be58.svg";